const baselayers = {
    baseLayer: {
        cursor: 'pointer',
        margin: 'auto',
    },
    image: {
        padding: '0px',
        width: '90px',
        height: '90px',
        margin: '6px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    labelText: {
        fontSize: 'smaller',
    },
    main: {
        marginLeft: '20px',
        marginBottom: '40px',
        maxWidth: '220px',
        // Factor in arrow width
        width: 'calc(100% - 50px)',
    },
    selected: {
        borderStyle: 'solid',
        borderColor: '#12A4B6',
    },
}

export default baselayers
